import { Disposiciones_esp } from './../../../models/disposiciones_esp.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material';
import * as moment from 'moment';

@Component({
    selector: "page-disposiciones_esp",
    templateUrl: "./disposiciones_especiales.component.html",
    styleUrls: ["./disposiciones_especiales.component.css"],
    providers: [FormService]
})

export class Disposiciones_espComponent {
    public rows = [];
    public actualRow;
    public disposiciones_esp: Disposiciones_esp;
    public form;
    public matcher = new FormService();
    public numberForm;
    public encontrado;


    public form111 = false;
    public form112 = false;
    public form113 = false;
    public form114 = false;

    public form131 = false;
    public form133 = false;

    public form211 = false;
    public form212 = false;
    public form213 = false;
    public form214 = false;

    public form231 = false;
    public form232 = false;
    public form233 = false;
    public form234 = false;
    public form235 = false;

    public form251;
    public form252;
    public form253;
    public form254;
    public form255;

    public fechaDesde;
    public fechaHasta;
    public maxDate;
    public esp;
    public nResolucion;

    constructor() {
        this.maxDate = moment().toDate()

        if (localStorage.getItem("form")) {
            this.numberForm = localStorage.getItem("form");


            if (this.numberForm == "1-3.1") {
                this.form131 = true
            }
            if (this.numberForm == "1-3.3") {
                this.form133 = true
            }



            if (this.numberForm == "1-1.1") {
                this.form111 = true
            }
            if (this.numberForm == "1-1.2") {
                this.form112 = true
            }
            if (this.numberForm == "1-1.3") {
                this.form113 = true
            }
            if (this.numberForm == "1-1.4") {
                this.form114 = true
            }

            if (this.numberForm == "2-1.1") {
                this.form211 = true
            }
            if (this.numberForm == "2-1.2") {
                this.form212 = true
            }
            if (this.numberForm == "2-1.3") {
                this.form213 = true
            }
            if (this.numberForm == "2-1.4") {
                this.form214 = true
            }
            if (this.numberForm == "2-3.1") {
                this.form231 = true;
            }
            if (this.numberForm == "2-3.2") {
                this.form232 = true;
            }
            if (this.numberForm == "2-3.3") {
                this.form233 = true;
            }
            if (this.numberForm == "2-3.4") {
                this.form234 = true;
            }
            if (this.numberForm == "2-3.5") {
                this.form235 = true;
            }

            if (this.numberForm == "2-5.1") {
                this.form251 = true;
            }
            if (this.numberForm == "2-5.2") {
                this.form252 = true;
            }
            if (this.numberForm == "2-5.3") {
                this.form253 = true;
            }
            if (this.numberForm == "2-5.4") {
                this.form254 = true;
            }
            if (this.numberForm == "2-5.5") {
                this.form255 = true;
            }
        }

        this.form = new FormGroup({
            disposicion1: new FormControl('', Validators.required),
            disposicion2: new FormControl('', Validators.required),
            disposicion3: new FormControl('', Validators.required),
            disposicion4: new FormControl('', Validators.required),
            disposicion5: new FormControl('', Validators.required),
            disposicion6: new FormControl('', Validators.required),
            disposicion7: new FormControl('', Validators.required),
            disposicion8: new FormControl('', Validators.required),
            disposicion9: new FormControl('', Validators.required),
            disposicion10: new FormControl('', Validators.required),
            disposicion11: new FormControl('', Validators.required),
            disposicion12: new FormControl('', Validators.required),
            numero_resolucion: new FormControl('', Validators.required),
            fecha: new FormControl('', Validators.required),
            vigente: new FormControl('', Validators.required),
            especificar: new FormControl('', Validators.required)
        })
        if (!JSON.parse(localStorage.getItem("disposiciones_esp"))) {
            localStorage.setItem("disposiciones_esp", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("disposiciones_esp"));
            this.form.controls['disposicion1'].setValue(this.rows[0] ? this.rows[0].disposicion1 : false);
            this.form.controls['disposicion2'].setValue(this.rows[0] ? this.rows[0].disposicion2 : false);
            this.form.controls['disposicion3'].setValue(this.rows[0] ? this.rows[0].disposicion3 : false);
            this.form.controls['disposicion4'].setValue(this.rows[0] ? this.rows[0].disposicion4 : false);
            this.form.controls['disposicion5'].setValue(this.rows[0] ? this.rows[0].disposicion5 : false);
            this.form.controls['disposicion6'].setValue(this.rows[0] ? this.rows[0].disposicion6 : false);
            this.form.controls['disposicion7'].setValue(this.rows[0] ? this.rows[0].disposicion7 : false);
            this.form.controls['disposicion8'].setValue(this.rows[0] ? this.rows[0].disposicion8 : false);
            this.form.controls['disposicion9'].setValue(this.rows[0] ? this.rows[0].disposicion9 : false);
            this.form.controls['disposicion10'].setValue(this.rows[0] ? this.rows[0].disposicion10 : false);
            this.form.controls['disposicion11'].setValue(this.rows[0] ? this.rows[0].disposicion11 : false);
            this.form.controls['disposicion12'].setValue(this.rows[0] ? this.rows[0].disposicion12 : false);
            this.form.controls['numero_resolucion'].setValue(this.rows[0] ? this.rows[0].numero_resolucion : "");
            this.form.controls['fecha'].setValue(this.rows[0] ? this.rows[0].fecha : "");
            this.form.controls['vigente'].setValue(this.rows[0] ? this.rows[0].vigente : "");
            this.form.controls['especificar'].setValue(this.rows[0] ? this.rows[0].especificar : "");
        }

        this.disposiciones_esp = {
            disposicion1: '',
            disposicion2: '',
            disposicion3: '',
            disposicion4: '',
            disposicion5: '',
            disposicion6: '',
            disposicion7: '',
            disposicion8: '',
            disposicion9: '',
            disposicion10: '',
            disposicion11: '',
            disposicion12: '',
            numero_resolucion: '',
            fecha: '',
            vigente: '',
            especificar: ''
        };


    }

    add_disposiciones_esp(event?: MatDatepickerInputEvent<Date>, type?) {

        if (this.form.value.disposicion9) {
            this.nResolucion = this.form.value.numero_resolucion
            this.fechaDesde = this.form.value.fecha ? moment(this.form.value.fecha).format('DD/MM/YYYY') : ""
            this.fechaHasta = this.form.value.vigente ? moment(this.form.value.vigente).format('DD/MM/YYYY') : ""

        } else {
            this.fechaDesde = ""
            this.fechaHasta = ""
            this.nResolucion = ""
        }

        if (this.form.value.disposicion10) {
            this.esp = this.form.value.especificar
        } else {
            this.esp = ""
        }

        localStorage.setItem("disposiciones_esp", JSON.stringify([]));
        this.actualRow = localStorage.getItem("disposiciones_esp");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            disposicion1: this.form.value.disposicion1,
            disposicion2: this.form.value.disposicion2,
            disposicion3: this.form.value.disposicion3,
            disposicion4: this.form.value.disposicion4,
            disposicion5: this.form.value.disposicion5,
            disposicion6: this.form.value.disposicion6,
            disposicion7: this.form.value.disposicion7,
            disposicion8: this.form.value.disposicion8,
            disposicion9: this.form.value.disposicion9,
            disposicion10: this.form.value.disposicion10,
            disposicion11: this.form.value.disposicion11,
            disposicion12: this.form.value.disposicion12,
            numero_resolucion: this.nResolucion,
            fecha: this.fechaDesde,
            vigente: this.fechaHasta,
            especificar: this.esp
        })
        localStorage.setItem("disposiciones_esp", JSON.stringify(this.rows));

    }

    delete_disposiciones_esp(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("disposiciones_esp", JSON.stringify(this.rows));
            }
        }
    }

}